import { render } from "./App.vue?vue&type=template&id=fd2ccee2"
const script = {}
script.render = render

export default script